/** Laravel broadcast and inbox payload used by the authenticated portal. */
export type PortalNotification = {
  id: string;
  type: 'customer_signature_captured' | 'customer_document_uploaded' | string;
  title: string;
  message: string;
  quotation_no: string;
  metadata: {
    payment_reference?: string;
    document_type?: string;
    filename?: string;
    uploaded_document_names?: string[];
    request_status?: 'pending' | 'partial' | 'complete';
    decision?: 'accepted' | 'approved' | 'rejected';
    approved_days?: number | null;
    credit_request_id?: string;
    receipt_id?: number | null;
    receipt_no?: string | null;
    submission_id?: number | null;
    response_comment?: string | null;
    source_quotation_no?: string;
    total_revisions?: number;
  };
  created_at: string;
  read_at?: string | null;
};

/**
 * Resolve a notification to an existing portal route.
 * The motor documentation page owns document review and signature approval;
 * `quotationNo` and the focus parameters are read by that page.
 * @param notification Broadcast or recovered backend notification.
 * @returns An encoded, internal frontend URL.
 */
export function notificationHref(notification: PortalNotification): string {
  const base = `/dashboard/products/motor/documentation?quotationNo=${encodeURIComponent(notification.quotation_no)}`;
  switch (notification.type) {
    case 'motor_payment_updated':
      return `${base}&notificationFocus=payment`;
    case 'motor_credit_approved':
    case 'motor_credit_rejected':
    case 'motor_credit_requested':
      return `${base}&notificationFocus=credit`;
    case 'motor_further_discount_accepted':
    case 'motor_further_discount_rejected':
      return `/dashboard/products/motor/quote?quotationNo=${encodeURIComponent(notification.quotation_no)}&totalRev=${notification.metadata?.total_revisions ?? 1}`;
    case 'customer_signature_captured':
      return `${base}&notificationFocus=signature`;
    case 'customer_document_uploaded':
      return `${base}&notificationFocus=document&documentType=${encodeURIComponent(notification.metadata?.document_type ?? '')}`;
    default:
      return notification.type.startsWith('motor_') && /(payment|paid|cheque|online)/.test(notification.type)
        ? `${base}&notificationFocus=payment`
        : base;
  }
}
